import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import OldPaymentMethodSelect from '../old-payment-method-select/old-payment-method-select';
import PaymentMethodSelect from '../payment-method-select/payment-method-select';
import formatPriceToFloat from '../../../../utils/price/format-price-to-float';
import translation from '../../../../languages';
import { changeState } from '../../reducers';
import { resolvePreselectedPaymentOption } from '../../payment.helpers';

type DefaultPaymentPageProps = TranslationProps & {};

const DefaultPaymentPage = ({ t }: DefaultPaymentPageProps) => {
    const dispatch = useDispatch();
    const { paymentOptionsData, paymentCart } = useSelector((state: RootState) => state.payment);
    const [cartFinalPrice, setCartFinalPrice] = useState(0);

    useEffect(() => {
        if (!paymentOptionsData?.loaded) {
            return;
        }

        const defaultOption = resolvePreselectedPaymentOption(paymentOptionsData);

        if (defaultOption) {
            dispatch(changeState({ activePaymentOption: defaultOption }));
        }
    }, [paymentOptionsData]);

    useEffect(() => {
        if (paymentCart?.loaded) {
            setCartFinalPrice(formatPriceToFloat(paymentCart?.finalPrice) || 0);
        }
    }, [paymentCart?.loaded]);

    if (!paymentOptionsData) {
        return <></>;
    }

    return (
        <>
            {Boolean(cartFinalPrice > 0) && (
                paymentOptionsData?.showFallbackMethods
                    ? <OldPaymentMethodSelect/>
                    : <PaymentMethodSelect/>
            )}
        </>
    );
};

const translate = translation('payment');

export default translate(DefaultPaymentPage);
